export default {
  projects: [
    {
      title: 'Proyecto EISTU y TEP Homecenter Vallenar',
      customer: 'Falabella Inmobiliario',
      base: '/images/projects/1/',
      imgs: [
        '0.jpeg',
        '1.jpeg',
        '2.jpeg',
        '3.jpg',
        '4.jpeg',
        '5.jpg',
        '6.jpeg',
        '7.jpg',
        '8.jpg',
        '9.jpg',
        '10.jpeg',
        '11.jpg',
        '12.jpeg',
        '13.jpg',
        '14.jpeg',
        '15.jpeg',
        '16.jpeg',
        '17.jpeg',
        '18.jpeg',
        '19.jpeg',
        '20.jpeg',
        '21.jpeg',
        '23.jpeg',
        '24.jpeg',
        '25.jpeg',
        '26.jpeg',
        '27.jpeg',
        '28.jpeg',
        '29.jpeg',
      ]
    },
    {
      title: 'Cluster / GPON Rotura y Reposición de Pavimentos',
      customer: 'Entel',
      base: '/images/projects/2/',
      imgs: [
        '1.jpeg',
        '2.jpeg',
        '3.jpeg',
      ]
    },
    {
      title: 'Proyecto EISTU y TEP Open Plaza Kennedy',
      customer: 'Falabella Inmobiliario',
      base: '/images/projects/3/',
      imgs: [
        '0.jpeg',
        '1.jpeg',
        '2.jpg',
        '3.jpeg',
        '4.jpg',
        '5.jpeg',
        '6.jpg',
        '7.jpeg',
        '8.jpg',
        '9.jpeg',
        '10.jpeg',
        '11.jpeg',
        '12.jpeg',
        '13.jpeg',
        '14.jpeg',
        '15.jpeg',
        '16.jpeg',
        '17.jpeg',
        '18.jpeg',
        '19.jpeg',
        '20.jpeg',
        '21.jpeg',
        '22.jpeg',
        '23.jpeg',
        '24.jpeg',
        '25.jpeg',
        '26.jpeg',
        '27.jpeg',
        '28.jpeg',
        '29.jpeg',
        '30.jpeg',
        '31.jpeg',
        '32.jpeg',
        '33.jpeg',
        '34.jpeg',
        '35.jpeg',
        '36.jpeg',
        '37.jpeg',
        '38.jpeg',
        '39.jpeg',
        '40.jpeg',
        '41.jpeg',
        '42.jpeg',
        '43.jpeg',
        '44.jpeg',
        '45.jpeg',
        '46.jpeg',
        '47.jpeg',
        '48.jpeg',
        '49.jpeg',
        '50.jpeg',
        '51.jpeg',
        '52.jpeg',
        '53.jpeg',
        '54.jpeg',
        '55.jpeg',
        '56.jpeg',
        '57.jpeg',
        '58.jpeg',
        '59.jpeg',
        '60.jpeg',
        '61.jpeg',
        '62.jpeg',
        '63.jpeg',
        '64.jpeg',
        '65.jpeg',
        '66.jpeg',
        '67.jpeg',
        '68.jpeg',
        '69.jpeg',
        '70.jpeg',
      ]
    },
    {
      img: '/images/services/no-image.jpg',
      title: 'Proyecto EISTU y TEP Tottus la Cisterna',
      customer: 'Tottus',
      base: '/images/projects/4/',
      imgs: [
        '0.jpeg',
        '1.jpeg',
        '2.jpeg',
        '3.jpeg',
        '4.jpeg',
        '5.jpeg',
        '6.jpeg',
        '7.jpeg',
        '8.jpeg',
        '9.jpeg',
        '10.jpeg',
        '11.jpeg',
        '12.jpeg',
        '13.jpeg',
        '14.jpeg',
        '15.jpeg',
        '16.jpeg',
        '17.jpeg',
        '18.jpeg',
        '19.jpeg',
        '20.jpeg',
        '21.jpeg',
        '22.jpeg',
        '23.jpeg',
        '24.jpeg',
        '25.jpeg',
        '26.jpeg',
      ]
    },
    {
      title: 'Proyecto EISTU Tottus Rengo',
      customer: 'Tottus',
      base: '/images/projects/5/',
      imgs: [
        '0.jpeg',
        '1.jpeg',
        '2.jpeg',
        '3.jpeg',
        '4.jpeg',
        '5.jpeg',
        '6.jpeg',
        '7.jpeg',
        '8.jpeg',
      ]
    },
    /*{
      title: 'Proyecto EISTU Tottus San Felipe',
      customer: 'Tottus',
      base: '/images/projects/6/',
      imgs: [
        '',
      ]
    },*/
    {
      title: 'Obra de Semaforización Mall Plaza Egaña',
      customer: 'TekChile',
      base: '/images/projects/7/',
      imgs: [
        '0.jpeg',
        '1.jpeg',
        '2.jpeg',
        '3.jpeg',
        '4.jpeg',
        '5.jpeg',
        '6.jpeg',
        '7.jpeg',
        '8.jpeg',
      ]
    },
    {
      title: 'Proyecto Serviu Y Mitigaciones AVB-CD Tottus, Quilicura',
      customer: 'Tottus',
      base: '/images/projects/8/',
      imgs: [
        '4.jpeg',
        '1.jpeg',
        '2.jpeg',
        '3.jpeg',
        '5.jpeg',
        '6.jpeg',
        '7.jpeg',
      ]
    },
    {
      title: 'Proyecto TEP, IVB Y MM, Padre Hurtado, Las condes',
      customer: 'AyP',
      base: '/images/projects/9/',
      imgs: [
        '1.jpeg',
        '2.jpeg',
        '3.jpeg',
        '4.jpeg',
        '5.jpeg',
        '6.jpeg',
        '7.jpeg',
        '8.jpeg',
        '9.jpeg',
        '10.jpeg',
        '11.jpeg',
        '12.jpeg',
        '13.jpeg',
        '14.jpeg',
        '15.jpeg',
        '16.jpeg',
      ]
    },
    {
      title: 'Proyecto Habilitación locales comerciales Homecenter, Arica',
      customer: 'Falabella Inmobiliario',
      base: '/images/projects/10/',
      imgs: [
        '0.jpeg',
        '1.jpeg',
        '2.jpeg',
        '3.jpeg',
        '4.jpeg',
        '5.jpeg',
        '6.jpeg',
        '7.jpeg',
        '8.jpeg',
        '10.jpeg',
        '11.jpeg',
        '12.jpeg',
        '13.jpeg',
        '14.jpeg',
        '15.jpeg',
        '16.jpeg',
        '17.jpeg',
        '18.jpeg',
        '19.jpeg',
      ]
    },
    {
      title: 'Proyectos Entel GPON (V región y región Metropolitana)',
      customer: 'Entel',
      base: '/images/projects/11/',
      imgs: [
        '1.jpeg',
        '2.jpeg',
        '3.jpeg',
        '4.jpeg',
      ]
    },
  ],
  others: [
    {
      title: 'Proyecto EISTU, TEP, SERVIU y MOP. Homecenter Vallenar.',
      customer: 'Mandante: Falabella Inmobiliario'
    },
    {
      title: 'Proyecto Cluster/GPON Rotura y Reposición de Pavimentos.',
      customer: 'Mandante: Entel'
    },
    {
      title: 'Proyecto SERVIU y MM AVB CD Tottus, Quilicura.',
      customer: 'Mandante: Hipermercados Tottus'
    },
    {
      title: 'Pavimentos Tottus San Felipe.',
      customer: 'Mandante:  Rentas Falabella'
    },
    {
      title: 'Proyecto TEP, SERVIU Y MM IVB Edificio Padre Hurtado, Las Condes.',
      customer: 'Mandante: A&P'
    },
    {
      title: 'Mitigaciones Pavimentos, Pilas y Muro Shotcrete. ',
      customer: 'Mandante: Edificio Sidepa'
    },
    {
      title: 'Proyecto Habilitación Locales Comerciales, Homecenter, Arica.',
      customer: 'Mandante: Falabella Inmobiliario'
    },
    {
      title: 'Proyecto EISTUy TEP Tottus la Cisterna. ',
      customer: 'Mandante: Hipermercados Tottus '
    },
    {
      title: 'Proyecto EISTU y TEP Open Plaza Kennedy. ',
      customer: 'Mandante: Falabella Inmobiliario'
    },
    {
      title: 'Proyecto EISTUTottus San Felipe.',
      customer: 'Mandante: Hipermercados Tottus'
    },
    {
      title: 'Proyecto de Pavimentación y Semaforización Vicuña Mackenna con Miraflores, Renca.',
      customer: 'Mandante: Tek Chile - I.M. Renca'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/config.projects.js